import React from "react";

import AppModal from "../common/AppModal";
import UpdateStudentTermReportForm from "../../forms/UpdateStudentTermReportForm";
import { StudentTermReportResponseDto } from "../../shared/dtos/studentTermReport/StudentTermReportResponseDto";

interface UpdateStudentTermReportModalProps {
  open: boolean;
  onClose: () => void;
  report: StudentTermReportResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateStudentTermReportModal: React.FC<
  UpdateStudentTermReportModalProps
> = ({ open, onClose, report, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Update Remarks: ${report?.studentName || ""}`}
      width="sm"
      loading={loading}
    >
      <UpdateStudentTermReportForm
        report={report}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};

export default UpdateStudentTermReportModal;
